import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'antd'
import fetchAPI from '../../../../../lib/utils/fetch-api'
import { isFormDataRequired } from '../../../../../lib/utils/collections'

export function useSaveResult() {
  const navigate = useNavigate()

  const saveResult = useCallback(
    async (
      id: string | undefined,
      formData: any,
      schema: any,
      isNew: boolean = false,
    ): Promise<boolean> => {
      if (!formData || !schema) {
        return false
      }

      // Проверяем обязательные поля
      const isRequired = isFormDataRequired(formData, schema)
      if (!isRequired) {
        Modal.warning({
          title: 'Предупреждение',
          content: 'Заполните все обязательные поля',
        })
        return false
      }

      try {
        if (isNew || id === 'new') {
          // Создание нового сотрудника
          const response = await fetchAPI('/api/hr/employees', {
            method: 'POST',
            body: JSON.stringify(formData),
          })

          if (response?.id) {
            navigate(`/hr/employees/${response.id}`)
            Modal.success({
              title: 'Успешно',
              content: 'Сотрудник успешно создан',
            })
            return true
          }

          Modal.error({
            title: 'Ошибка',
            content: 'Не удалось создать сотрудника',
          })
          return false
        }

        // Обновление существующего сотрудника
        await fetchAPI(`/api/hr/employees/${id}`, {
          method: 'POST',
          body: JSON.stringify(formData),
        })

        Modal.success({
          title: 'Успешно',
          content: 'Данные сотрудника успешно обновлены',
        })

        return true
      } catch (error: any) {
        Modal.error({
          title: 'Ошибка',
          content: error?.message || 'Не удалось сохранить данные',
        })
        return false
      }
    },
    [navigate],
  )

  return {
    saveResult,
  }
}
